import { render, staticRenderFns } from "./ProductCardSpecial.vue?vue&type=template&id=4e6531ce"
import script from "./ProductCardSpecial.vue?vue&type=script&lang=js"
export * from "./ProductCardSpecial.vue?vue&type=script&lang=js"
import style0 from "./ProductCardSpecial.vue?vue&type=style&index=0&id=4e6531ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports